<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <!-- Diretores -->
        <v-flex class="nome-subordinados lightgrey dark--text">Diretores</v-flex>
        <hierarquia-membro
            :membros="value"
            nivel="diretor"
            :id_usuario_superior="0"
            :autocomplete_params="params"
            v-on="$listeners">
            <template v-slot:membro="{ membro: diretor }">

                <!-- Regionais -->
                <v-flex class="nome-subordinados lightgrey dark--text">Regionais</v-flex>
                <hierarquia-membro
                    :diretor_index="diretor.index"
                    :membros="diretor.regionais"
                    nivel="regional"
                    :id_usuario_superior="diretor.hierarquia.id_usuario"
                    :autocomplete_params="params"
                    v-on="$listeners"
                    permite_usuario_fantasma>
                    <template v-slot:membro="{ membro: regional }">

                        <!-- Gerentes -->
                        <v-flex class="nome-subordinados lightgrey dark--text">Gerentes</v-flex>
                        <hierarquia-membro
                            :diretor_index="diretor.index"
                            :regional_index="regional.index"
                            :membros="regional.gerentes"
                            nivel="gerente"
                            :id_usuario_superior="regional.hierarquia.id_usuario"
                            :superior_fantasma="regional.hierarquia.usuario.usuario_fantasma"
                            :id_usuario_superior_fantasma="regional.hierarquia.usuario.id_usuario_fantasma"
                            :autocomplete_params="params"
                            v-on="$listeners"
                            permite_usuario_fantasma>
                            <template v-slot:membro="{ membro: gerente }">

                                <!-- Supervisores -->
                                <v-flex class="nome-subordinados lightgrey dark--text">Supervisores</v-flex>
                                <hierarquia-membro
                                    :diretor_index="diretor.index"
                                    :regional_index="regional.index"
                                    :gerente_index="gerente.index"
                                    :membros="gerente.supervisor"
                                    nivel="supervisor"
                                    :id_usuario_superior="gerente.hierarquia.id_usuario"
                                    :superior_fantasma="gerente.hierarquia.usuario.usuario_fantasma"
                                    :id_usuario_superior_fantasma="gerente.hierarquia.usuario.id_usuario_fantasma"
                                    :autocomplete_params="params"
                                    v-on="$listeners"
                                    permite_usuario_fantasma>
                                    <template v-slot:membro="{ membro: supervisor }">
                                        <!-- Vendedores -->
                                        <v-flex class="nome-subordinados lightgrey dark--text">Vendedores</v-flex>
                                        <hierarquia-membro
                                            :diretor_index="diretor.index"
                                            :regional_index="regional.index"
                                            :gerente_index="gerente.index"
                                            :supervisor_index="supervisor.index"
                                            :membros="supervisor.vendedores"
                                            nivel="vendedor"
                                            :id_usuario_superior="supervisor.hierarquia.id_usuario"
                                            :superior_fantasma="supervisor.hierarquia.usuario.usuario_fantasma"
                                            :id_usuario_superior_fantasma="supervisor.hierarquia.usuario.id_usuario_fantasma"
                                            :autocomplete_params="params"
                                            v-on="$listeners"
                                            readonly />
                                        <v-btn flat v-ripple="false" color="dark" class="btn-add pa-0 ma-0" @click="addVendedor(diretor.index, regional.index, gerente.index, supervisor.index)">
                                            <v-icon class="add-icon grey white--text mr-1">add</v-icon>
                                            Adicionar Vendedor
                                        </v-btn>
                                    </template>
                                </hierarquia-membro>
                                <v-btn flat v-ripple="false" color="dark" class="btn-add pa-0 ma-0" @click="addSupervisor(diretor.index, regional.index, gerente.index)">
                                    <v-icon class="add-icon grey white--text mr-1">add</v-icon>
                                    Adicionar Supervisor
                                </v-btn>
                            </template>
                        </hierarquia-membro>
                        <v-btn flat v-ripple="false" color="dark" class="btn-add pa-0 ma-0" @click="addGerente(diretor.index, regional.index)">
                            <v-icon class="add-icon grey white--text mr-1">add</v-icon>
                            Adicionar Gerente
                        </v-btn>
                    </template>
                </hierarquia-membro>
                <v-btn flat v-ripple="false" color="dark" class="btn-add pa-0 ma-0" @click="addRegional(diretor.index)">
                    <v-icon class="add-icon grey white--text mr-1">add</v-icon>
                    Adicionar Regional
                </v-btn>
            </template>
        </hierarquia-membro>
        <v-btn flat v-ripple="false" color="dark" class="btn-add pa-0 ma-0" :disabled="max_diretores_atingido" @click="addDiretor">
            <v-icon class="add-icon grey white--text mr-1">add</v-icon>
            {{ max_diretores_atingido ? `O número máximo de diretores é ${max_diretor}` : 'Adicionar Diretor' }}
        </v-btn>
    </div>
</template>

<script>
const membroVazio = () => ({
  id_hierarquia: null,
  hierarquia: {
    id_usuario: 0,
    usuario: {
      usuario_fantasma: false,
      id_usuario_fantasma: undefined
    }
  },
  editando: true,
  opened: false
})

export default {
  name: 'Hierarquia',
  props: {
    value: {
      type: Array
    },
    id_unidade_negocio: {
      type: Number,
      required: true
    }
  },
  computed: {
    max_diretor: () => 5,
    max_diretores_atingido () {
      return this.value.length >= this.max_diretor
    },
    ids_usuarios () {
      function getIdsUsuario (membros) {
        return membros
          .map(membro => membro.hierarquia.id_usuario)
          .filter(id_usuario => !!id_usuario) // Limpa qualquer id_usuario 0 ou null
      }

      const diretores = this.value
      const id_usuario_diretores = getIdsUsuario(diretores)

      const regionais = diretores.flatMap(d => d.regionais)
      const id_usuario_regionais = getIdsUsuario(regionais)

      const gerentes = regionais.flatMap(r => r.gerentes)
      const id_usuario_gerentes = getIdsUsuario(gerentes)

      const supervisores = gerentes.flatMap(g => g.supervisor)
      const id_usuario_supervisores = getIdsUsuario(supervisores)

      const vendedores = supervisores.flatMap(s => s.vendedores)
      const id_usuario_vendedores = getIdsUsuario(vendedores)

      return [
        ...id_usuario_diretores,
        ...id_usuario_regionais,
        ...id_usuario_gerentes,
        ...id_usuario_supervisores,
        ...id_usuario_vendedores
      ]
    },
    params () {
      return {
        not: this.ids_usuarios,
        id_unidade_negocio: this.id_unidade_negocio
      }
    }
  },
  methods: {
    addDiretor () {
      const diretores = this.value
      diretores.push({
        ...membroVazio(),
        regionais: []
      })
      this.$emit('updateMembro', {
        indices: {},
        membro: { diretores }
      })
    },
    addRegional (diretor_index) {
      const regionais = this.value[diretor_index].regionais
      regionais.push({
        ...membroVazio(),
        gerentes: []
      })
      this.$emit('updateMembro', {
        indices: { diretor_index },
        membro: { regionais }
      })
    },
    addGerente (diretor_index, regional_index) {
      const gerentes = this.value[diretor_index]
        .regionais[regional_index]
        .gerentes
      gerentes.push({
        ...membroVazio(),
        supervisor: []
      })
      this.$emit('updateMembro', {
        indices: { diretor_index, regional_index },
        membro: { gerentes }
      })
    },
    addSupervisor (diretor_index, regional_index, gerente_index) {
      const supervisores = this.value[diretor_index]
        .regionais[regional_index]
        .gerentes[gerente_index]
        .supervisor
      supervisores.push({
        ...membroVazio(),
        vendedores: []
      })
      this.$emit('updateMembro', {
        indices: { diretor_index, regional_index, gerente_index },
        membro: { supervisores }
      })
    },
    addVendedor (diretor_index, regional_index, gerente_index, supervisor_index) {
      const vendedores = this.value[diretor_index]
        .regionais[regional_index]
        .gerentes[gerente_index]
        .supervisor[supervisor_index]
        .vendedores
      vendedores.push({
        ...membroVazio()
      })
      this.$emit('updateMembro', {
        indices: { diretor_index, regional_index, gerente_index, supervisor_index },
        membro: { vendedores }
      })
    }
  }
}
</script>

<style scoped>
    .nome-subordinados {
        border-radius: 5px;
        max-width: 150px !important;
        text-align: center;
        text-transform: uppercase;
        font-size: 12px;
        font-weight: bold;
        padding: 5px;
    }
</style>
